/**
 * Represents filters for searching for users.
 */
export class UserFilter {

    /**
     *
     * @param companyId
     * @param account
     * @param role
     */
    constructor(companyId, account, role) {
        this._companyId = companyId;
        this._account = account;
        this._role = role;

    }

    /**
     * Gets the company Id
     * @returns {string}
     */
    get companyId() {
        return this._companyId;
    }

    /**
     * Gets the account
     * @returns {string}
     */
    get account() {
        return this._account;
    }

    /**
     * Gets the role.
     * @returns {string}
     */
    get role() {
        return this._role;
    }

}